<template>
  <div class="container withdraw">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item :to="{ path: '/' }">用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>推荐返佣管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">推荐返佣管理</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleTypeCreate"
          >添加返佣类型</el-button>
        </div>
      </div>
    </div>
    <div class="results card">
      <p class="title">返佣类型</p>
      <div class="values">
        <el-table
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="product_type"
            label="返佣类型"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ types[scope.row.product_type] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="charge_rate"
            label="单笔交易返佣比"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ `${scope.row.charge_rate * 100}%` }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="charge_amount"
            label="单笔交易固定返佣"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="创建时间"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{  $moment(scope.row.create_time).format('YYYY-MM-DD HH:mm:ss')  }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="最后编辑时间"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{  $moment(scope.row.update_time).format('YYYY-MM-DD HH:mm:ss')  }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
            align="center"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <div class="menu-wrap">
                <el-button
                  size="mini"
                  type="text"
                  @click="handleTypeEdit(scope.row)"
                >编辑</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleTypeEdit(scope.row)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <MarketingChargeCreateDialog
      :visible="createVisible"
      :content="results"
      @submit="fetchTypeList"
      @close="createVisible = false"
    />
    <MarketingChargeEditDialog
      :visible="editVisible"
      :content="typeInfo"
      @submit="fetchTypeList"
      @close="editVisible = false"
    />
  </div>
</template>

<script>
import MarketingChargeCreateDialog from '@/components/dialog/member/MarketingChargeCreate'
import MarketingChargeEditDialog from '@/components/dialog/member/MarketingChargeEdit'
import { marketingChargeList } from '@/api/operation'

export default {
  components: {
    MarketingChargeCreateDialog,
    MarketingChargeEditDialog
  },
  data() {
    return {
      createVisible: false,
      editVisible: false,
      typeInfo: {},
      results: [],
      types: { '1': '课程', '2': '题库', '3': '阅读资料', '4': '实体资料' },
      isfixed: document.body.clientWidth < 820 ? false : true,
    }
  },
  created() {
    this.fetchTypeList()
  },
  methods: {
    fetchTypeList() {
      marketingChargeList({ isPaging: 0 }).then(res => {
        this.results = res.list
      })
    },
    // 服务类型创建
    handleTypeCreate() {
      this.createVisible = true
    },
    handleVerify() {
      this.dialogVisible = true
    },
    handleTypeEdit(row) {
      this.typeInfo = row
      this.editVisible = true
    }
  }
}
</script>

<style scoped lang="less">
.withdraw {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        font-size: 14px;
        padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: 10px;

      .name {
        width: 120px;
      }
      .phone {
        width: 120px;
      }
      .datetime {
        width: 380px;
      }
    }
    .filter-item {
      display: flex;

      .label {
        margin-right: 10px;
        padding-top: 8px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        border-radius: 4px;
        padding: 8px;
        margin-right: 5px;
        margin-bottom: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
    .divider {
      border-bottom: 1px dashed #ccc;
      margin: 10px 0;
    }
  }
  .results {
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .menu-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
